import { useState } from "react";
import { Popover, IconButton, Typography, Box, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

// Component for handling message display with popover
const MessageCell = ({ message }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "message-popover" : undefined;

  // Check if text needs truncation
  const maxLength = 30;
  const needsTruncation = message && message.length > maxLength;

  // Truncate text for preview
  const truncateText = (text, maxLength = 50) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  // If text doesn't need truncation, show it normally
  if (!needsTruncation) {
    return (
      <span
        style={{
          maxWidth: 250,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {message || ""}
      </span>
    );
  }

  const renderWithIcon = () => (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <span
        style={{
          maxWidth: 250,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          flex: 1,
        }}
      >
        {truncateText(message)}
      </span>
      <Tooltip title="Click to view full message">
        <IconButton
          size="small"
          onClick={handleClick}
          aria-describedby={id}
          sx={{
            ml: 0.5,
            p: 0.5,
            "&:hover": {
              backgroundColor: "primary.100",
            },
          }}
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );

  return (
    <>
      {renderWithIcon()}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiPopover-paper": {
            p: 2,
            maxWidth: 400,
            maxHeight: 300,
            overflow: "auto",
          },
        }}
      >
        <div>
          <Typography
            variant="body2"
            sx={{
              wordBreak: "break-word",
              lineHeight: 1.6,
              whiteSpace: "pre-wrap",
            }}
          >
            {message}
          </Typography>
        </div>
      </Popover>
    </>
  );
};

export default MessageCell;
